import type { components } from "@/api/types";

export type MyRobotCard = components["schemas"]["MyRobotCard"];
export type MyRobotDetail = components["schemas"]["MyRobotDetail"];
export type DailyResultItem = components["schemas"]["DailyResultItem"];

/**
 * Статус купленного робота. В контракте это свободная строка, здесь union —
 * ровно два значения, и по ним строится ключ перевода `myRobots.status.*`.
 * Варианты `Paused` и `Error` из `StatusChip/Robot` (11:119) не используются:
 * бэкенд их не выдаёт (DESIGN.md §8).
 */
export type UserRobotStatus = "active" | "stopped";

export function asUserRobotStatus(value: string): UserRobotStatus {
  return value === "stopped" ? "stopped" : "active";
}
